import { apiRequest } from "../util/apiUtils";

export const orderList = async (params) => {
  try {
    const res = await apiRequest("get", `order/order-list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const orderAddEdit = async (payload) => {
  try {
    const res = await apiRequest(payload?.id ? "put" : "post", `order/backend/${payload?.id ? "edit" : "add"}`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const orderDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `/order/backend/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const manualPayment = async (payload) => {
  try {
    const res = await apiRequest("post", `/process-manual-payment`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const cashPayment = async (payload) => {
  try {
    const res = await apiRequest("post", `/process-cash-payment`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

